export default {
  init() {
    // JavaScript to be fired on all pages

    $('#mobile-menu-toggle').on('click', function() {
      $('#mobile-menu-panel').addClass('active');
    });

    $('#close-mobile-menu-panel').on('click', function() {
      $('#mobile-menu-panel').removeClass('active');
      setTimeout(() => {
        $('.nav-mobile .menu-item-has-children').removeClass('active');
        $('.nav-mobile .menu-item-has-children .sub-menu').addClass('close');
        $('.nav-mobile .menu-item-has-children .sub-menu').slideUp(400);
      }, 300);
    });

    // Initialise collapse for mobile nav menu
    var idx = 1;

    $('.nav-mobile .menu-item-has-children').each(function() {
      console.log('each', 'processing...');
      var elm = $(this);

      // Setting up collapse
      elm.find('.sub-menu').attr('id', 'mobile-submenu-' + idx);
      elm.find('.sub-menu').addClass('mobile-submenu collapse close');
      elm.find('.sub-menu').slideUp(400);

      // Setting up toggle
      elm.attr('data-target', '#mobile-submenu-' + idx);
      elm.attr('data-group', '.mobile-submenu');
      elm.attr('data-limit', 'one');
      elm.addClass('collapse-toggle mobile-submenu');

      idx++;
    });

    // Collapse ////////////////////////////////////////////////////////
    // Initialized collapse elements
    setTimeout(() => {
      $('.collapse').each(function() {
        var elm = $(this);

        if (
          elm.hasClass('show') &&
          elm.prev('.collapse-toggle').hasClass('active')
        ) {
          elm.show();
        }
      });
    }, 500);

    // When collapse toggle is clicked
    $('body').on('click', '.collapse-toggle', function() {
      var toggle = $(this);
      var group = toggle.data('group');
      var target = $(toggle.data('target'));
      var limit = toggle.data('limit');

      if (limit === 'any') {
        // target.toggleClass('close');
        target.slideToggle(400);

        toggle.toggleClass('active');
      } else {
        if (toggle.hasClass('active')) {
          toggle.removeClass('active');

          // target.addClass('close');
          target.slideUp(400);
        } else {
          $(group + '.collapse-toggle').removeClass('active');
          toggle.addClass('active');

          // $(group + '.collapse').addClass('close');
          $(group + '.collapse').slideUp(400);

          // target.removeClass('close');
          target.slideDown(400);
        }
      }

      var slickTarget = toggle.data('slick');

      if (slickTarget !== undefined) {
        var slideIndex = toggle.data('goto');

        $(slickTarget).slick('slickGoTo', parseInt(slideIndex));
      }

      var autoscroll = toggle.data('autoscroll');

      if (autoscroll) {
        setTimeout(() => {
          $('html,body').animate(
            {
              scrollTop: toggle.offset().top,
            },
            1000
          );
        }, 500);
      }
    });

    // When window resize update collapse element height
    // $(window).resize(function () {
    //   $('.collapse').each(function () {
    //     var elm = $(this);

    //     if (elm.find('.collapse').length > 0 && elm.hasClass('parent-collapse')) {
    //       // is nested collapse
    //       // var totalHeight = 0;

    //       // elm.find('.collapse').each(function () {
    //       //   var child = $(this);
    //       //   totalHeight = totalHeight + child[0].scrollHeight;
    //       // });

    //       // elm[0].style.maxHeight = 'auto';
    //       // elm[0].style.maxHeight = totalHeight + 'px';

    //     } else {
    //       elm[0].style.height = 'auto';
    //       var h = elm[0].scrollHeight;
    //       elm[0].style.height = h + 'px';
    //     }
    //   });
    // });
    // Collapse //////////////////////////////////////////////////////// END

    var autoplay = true;
    // if ($('#footer-logo-carousel').data('autoplay') === 'on') { autoplay = true; }
    
    // console.log('autoplay', $('#footer-logo-carousel').data('autoplay'), autoplay);
    

    // Footer logo carousel
    $('.logo-carousel__list').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: false,
      autoplay: autoplay,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
      ],
    });

    // Image carousel
    $('.image-carousel').each(function() {
      $(this).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
            },
          },
        ],
      });
    });

    // Photos Slider
    $(document).on('click', function(e) {
      // on click certain dpd cards, external link will be opened in new tab
      if ($(e.target).hasClass('dpd-card_open-external-link')) {
        var elm = $(e.target);
        const link = elm.data('external-link');
        window.open(link, '_blank');
        return;
      } else if ($(e.target).hasClass('card-images')) {
        console.log('this is images card');
      } else {
        e.stopPropagation();
        return;
      }

      var elm = $(e.target);

      const id = elm.data('id');

      var data = {
        action: 'get_photos_slider',
        id: id,
      };

      // Ajax call to get library posts
      $.post(window.my_ajax_object.ajax_url, data, function(payload) {
        console.log('payload', JSON.parse(payload));

        if (data.photos !== '') {
          data = JSON.parse(payload);
          $('#overlay-photos-slider').html('');
          $('#overlay-photos-slider').html(data.photos);

          $('#overlay-photos-slider').slick({
            arrows: true,
            dots: true,
            appendDots: $('#overlay-photos-dots'),
          });

          $('#overlay-photos-slider').slick('slickGoTo', 0);

          if (data.description !== '') {
            $('.overlay-photos-description').show();
            $('.overlay-photos-description').html(data.description);
          } else {
            $('.overlay-photos-description').hide();
            $('.overlay-photos-description').html('');
          }

          setTimeout(() => {
            $('#overlay-photos').fadeIn(400, function() {
              $('#overlay-loader').fadeOut();
            });
          }, 200);
        }
      });
    });

    // Close photos slider overlay
    $('.close-overlay-photos').on('click', function(e) {
      if (!$(this).hasClass('fake-close-overlay')) {
        $('#overlay-photos').fadeOut(500, function() {
          $('#overlay-photos-slider').slick('unslick');
        });
      }
    });

    // Catch click event from vue js cards
    // $(document).on('click', function (event) {
    //   console.log('clicked', event.target, $(event.target).data('id'));
    // });

    if ($('.single-fake-overlay').length > 0) {
      setTimeout(() => {
        $('.single-fake-overlay .dpd-card').click();
      }, 200);
    }

    /// image grid overlay
    $('.image-grid-overlay__trigger').on('click', function(e) {
      const el = $(this);
      const galleryId = el.data('gallery');
      let images = [];

      $(`[data-gallery="${galleryId}"]`).each(function() {
        images.push($(this).data('image'));
      });

      if (images.length > 0) {
        let photos;

        images.forEach(image => {
          photos =
            photos +
            `<div><div class="overlay-photo-slide" style="background-image: url(${image})"></div></div>`;
        });

        $('.overlay-photos-description').hide();
        $('.overlay-photos-description').html('');
        $('#overlay-photos-slider').html('');
        $('#overlay-photos-slider').html(photos);

        $('#overlay-photos-slider').slick({
          arrows: true,
          dots: true,
          appendDots: $('#overlay-photos-dots'),
        });

        const imgIndex = el.data('index');
        $('#overlay-photos-slider').slick('slickGoTo', imgIndex);

        setTimeout(() => {
          $('#overlay-photos').fadeIn();
        }, 200);
      }
    });

    // Tabs ///////////////
    // Init slider
    $('.tab__content-slider').each(function() {
      const id = $(this).attr('id');

      var options = {
        arrows: false,
        dots: false,
        fade: true,
        adaptiveHeight: true,
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
      };

      $('#' + id).slick(options);
    });

    // Tab switch
    if ($('.tab__switch').length > 0) {
      $('.tab__switch')
        .first()
        .addClass('active');

      $('.tab__switch').on('click', function() {
        const target = $(this).data('target');
        const slideIndex = $(this).data('index');

        $(`${target}.tab__content-slider`).slick(
          'slickGoTo',
          parseInt(slideIndex)
        );

        $('.tab__switch').removeClass('active');
        $(this).addClass('active');
      });
    }
    // Tabs //////////////////////////////////////////////////////// END

    // Talent detail overlay
    $('.talent-block').on('click', function() {
      const id = $(this).data('id');

      var data = {
        action: 'query_talent_detail',
        id: id,
      };

      // Ajax call to get library posts
      $.post(window.my_ajax_object.ajax_url, data, function(payload) {
        const result = JSON.parse(payload);

        // show thumbnail only if video not available
        if (result.thumbnail !== '' && result.video_id === '') {
          $('.overlay-post-thumbnail').show();
          $('.overlay-post-thumbnail').css(
            'background-image',
            'url(' + result.thumbnail + ')'
          );
        } else {
          $('.overlay-post-thumbnail').hide();
          $('.overlay-post-thumbnail').css('background-image', '');
        }

        if (result.video_id !== '') {
          $('.overlay-post-video').show();
          // $('.overlay-post-video').closest('.overlay-post-outer').find('.close-overlay').addClass('close-overlay-post-video');
        } else {
          $('.overlay-post-video').hide();
          // $('.close-overlay').removeClass('close-overlay-post-video');
        }

        if (result.title !== '') {
          $('.overlay-post-title').show();
          $('.overlay-post-title').html(result.title);
        } else {
          $('.overlay-post-title').hide();
          $('.overlay-post-title').html('');
        }

        if (result.description !== '') {
          $('.overlay-post-description').show();
          $('.overlay-post-description').html(result.description);
        } else {
          $('.overlay-post-description').hide();
          $('.overlay-post-description').html('');
        }

        setTimeout(() => {
          $('#overlay-post').fadeIn();
        }, 200);
      });
    });

    // Close post detail overlay
    $('.close-overlay-post').on('click', function() {
      $('#overlay-post').fadeOut(500, function() {
        // restore initial states if needed
      });
    });

    // Smooth scroll anchor links
    $('.anchor-link').on('click', function() {
      $('.anchor-link').removeClass('active');
      $(this).addClass('active');
      const target = $(this).data('target');

      $('html, body')
        .stop(true, false)
        .animate(
          {
            scrollTop: $(target).offset().top,
          },
          1000
        );
    });

    // Masonary haventopic blocks ///////////
    if ($('#haventopics-list').length) {
      let magicGrid = new MagicGrid({
        container: '#haventopics-list',
        static: true,
        useMin: true,
        gutter: 30,
        maxColumns: 2,
        center: true,
        //useTransform: false,
      });

      magicGrid.listen();
    }

    var event_page = 2;
    const btn_loadmore_event = $(
      '#event-list ~ #btn-loadmore-wrapper .btn-loadmore'
    );
    const event_max_page = $('#event-list').data('max-page');

    btn_loadmore_event.on('click', function() {
      const elm = $(this);
      const elmWrapper = $(this).parent('#btn-loadmore-wrapper');
      const loader = elm.siblings('#loader');
      var data = {
        action: 'load_event_posts_by_ajax',
        page: event_page,
        security: window.my_ajax_object.nonce,
        keyword: window.my_ajax_object.search_keyword,
      };
      elm.addClass('btn-disabled');
      loader.css('visibility', 'visible');

      $.post(window.my_ajax_object.ajax_url, data, function(response) {
        if ($.trim(response) != '') {
          $('#event-list').append(response);

          if(event_page === event_max_page){
            elmWrapper.hide();
          } else {
            event_page++;
          }

        } else {
          elmWrapper.hide();
        }
        elm.removeClass('btn-disabled');
        loader.css('visibility', 'hidden');
      });
    });

    // force autoplay video on ios
    // Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    //   get: function () {
    //     return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    //   },
    // });

    // const videoElement = document.getElementById('home-video');
    // $('body').on('click touchstart', function () {
    //   if (videoElement.playing) {
    //     // video is already playing so do nothing
    //   }
    //   else {
    //     // video is not playing
    //     // so play video now
    //     videoElement.play();
    //   }
    // }); $('body').click();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // console.log('finalizing...');

    $('.desktop-nav-news').append($('#news-submenu'));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js